import React from "react";
import { Link } from "react-router-dom";
import { scrollToTop } from "../../utils/scrollToTop";

const Navbar = () => {
  return (
    <div className="navbar-container lg:tw-inline-block main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
      <ul className="lg:tw-inline-block [&>li>a]:tw-text-black navbar-light">
        <li className="nav-item">
          <Link className="nav-link navbar-link" to="/" onClick={scrollToTop}>
            Home
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className="nav-link navbar-link"
            to="/chat-best-astrologer-free"
            onClick={scrollToTop}
          >
            Hello Astrologer
          </Link>
        </li>

        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle navbar-link"
            href="javascript:void(0)"
            data-bs-toggle="dropdown"
          >
            Horoscope
          </a>
          <ul className="dropdown-menu">
            <li>
              <Link
                className="dropdown-item tw-text-black"
                to="/today-horoscope-online"
                onClick={scrollToTop}
              >
                Daily Horoscope
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item tw-text-black"
                to="/weekly-horoscope"
                onClick={scrollToTop}
              >
                Weekly Horoscope
              </Link>
            </li>

            <li>
              <Link
                className="dropdown-item tw-text-black"
                to="/monthly-horoscope"
                onClick={scrollToTop}
              >
                Monthly Horoscope
              </Link>
            </li>

            <li>
              <Link
                className="dropdown-item tw-text-black"
                to="/yearly-horoscope"
                onClick={scrollToTop}
              >
                Yearly Horoscope
              </Link>
            </li>
          </ul>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link navbar-link"
            to="/todays-panchang-astrology"
            onClick={scrollToTop}
          >
            Panchang
          </Link>
        </li>
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle navbar-link"
            href="javascript:void(0)"
            data-bs-toggle="dropdown"
          >
            Kundli
          </a>
          <ul className="dropdown-menu">
            <li>
              <Link
                className="dropdown-item tw-text-black"
                to="/get-kundli-online"
              >
                Kundli
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item tw-text-black"
                to="/match-making-kundali-milan"
              >
                Kundli Milan
              </Link>
            </li>
          </ul>
        </li>
        {/* <li className="nav-item dropdown">
          <a
            style={{ color: "black" }}
            className="nav-link dropdown-toggle"
            href="javascript:void(0)"
            data-bs-toggle="dropdown"
          >
            Puja Path
          </a>
          <ul className="dropdown-menu">
            <li>
              <Link
                style={{ color: "black" }}
                className="dropdown-item"
                to="/online_puja"
              >
                Online-Puja
              </Link>
            </li>
            <li>
              <Link
                style={{ color: "black" }}
                className="dropdown-item"
                to="/book-puja-pandit"
              >
                Offline-Puja
              </Link>
            </li>
          </ul>
        </li> */}

        <li className="nav-item">
          <Link
            className="nav-link navbar-link"
            to="/book-puja-pandit"
            onClick={scrollToTop}
          >
            Puja Path
          </Link>
        </li>

        <li className="nav-item">
          <Link
            className="nav-link navbar-link"
            to="/tarot-cards-reading-online"
            onClick={scrollToTop}
          >
            Tarot
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link navbar-link"
            to="/free-numerology-reading"
            onClick={scrollToTop}
          >
            Numerology
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/shop-astrology-product" className="nav-link navbar-link">
            NeuShop
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link navbar-link"
            to="/astrology-blog"
            onClick={scrollToTop}
          >
            Blog
          </Link>
        </li>
        <li className="nav-item dropdown">
          <a
            className="nav-link dropdown-toggle tw-text-black navbar-link"
            href="javascript:void(0)"
            data-bs-toggle="dropdown"
          >
            Others
          </a>
          <ul className="dropdown-menu">
            <li>
              <Link
                className="dropdown-item tw-text-black"
                to="/shubh-muhurat-today"
                onClick={scrollToTop}
              >
                Muhurat
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item tw-text-black"
                to="/festival"
                onClick={scrollToTop}
              >
                Festivals
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
